<template>
  <v-dialog v-model="showDialog" max-width="500" persistent>
    <v-card>
      <v-card-title class="text-h5">
        {{ dialogConfig.title }}
      </v-card-title>

      <v-card-text>
        <p>{{ dialogConfig.description }}</p>
        <CatalogExportFilterSummary />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="grey" variant="text" :disabled="isLoading" @click="closeDialog">
          {{ $t("common.action.cancel") }}
        </v-btn>
        <v-btn
          color="primary"
          variant="text"
          :loading="isLoading"
          :disabled="isLoading"
          @click="confirmExport"
        >
          {{ dialogConfig.buttonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import i18n from "@/app/plugins/i18n";
import CatalogExportFilterSummary from "@/catalog/components/product/CatalogExportFilterSummary.vue";

const props = defineProps<{
  context: string;
}>();
const emit = defineEmits<{ confirm: [] }>();
const showDialog = ref(false);
const isLoading = ref(false);

const dialogConfig = computed(() => {
  if (props.context === "qr-codes") {
    return {
      title: i18n.global.t("common.action.printQRCodes"),
      description: i18n.global.t("common.message.printQRCodesDescription"),
      buttonText: i18n.global.t("common.action.printQRCodes"),
    };
  }

  return {
    title: i18n.global.t("common.action.confirmExport"),
    description: i18n.global.t("common.message.exportWithFilters"),
    buttonText: i18n.global.t("common.action.export"),
  };
});

const open = () => {
  showDialog.value = true;
};

const closeDialog = () => {
  showDialog.value = false;
};

const confirmExport = () => {
  isLoading.value = true;
  emit("confirm");
  setTimeout(() => {
    isLoading.value = false;
    closeDialog();
  }, 300);
};

defineExpose({ open, close: closeDialog });
</script>
